import { HistoryStore as BaseHistoryStore } from '@bn-games/history-core';
import { HISTORY_SCHEMA_VERSION, type GameRecord } from './types.js';

// Per-app singleton wrapping @bn-games/history-core's generic FIFO list with
// chess's storage key, schema version and shape predicate.
export const historyStore = new BaseHistoryStore<GameRecord>({
  storageKey: 'chess-history',
  schemaVersion: HISTORY_SCHEMA_VERSION,
  isValid: (parsed) => Array.isArray(parsed['moves']) && typeof parsed['startFen'] === 'string',
});
